export const dashboardKeys = {
  all: ['dashboard'] as const,
  periodInfo: () => [...dashboardKeys.all, 'period-info'] as const,
  metrics: () => [...dashboardKeys.all, 'metrics'] as const,
  potStatusSummary: () => [...dashboardKeys.all, 'pot-status-summary'] as const,
  weeklyAllocationTrend: () =>
    [...dashboardKeys.all, 'weekly-allocation-trend'] as const,
  unapprovedAllocations: () =>
    [...dashboardKeys.all, 'unapproved-allocations'] as const,
  openPots: () => [...dashboardKeys.all, 'open-pots'] as const,
};
